<template>
<div class="myPrivileges">
	<div class="myPrivileges-out">
		<p class="myPrivileges-tit">我的特权</p>
		<p class="myPrivileges-des">加快求职速度，快人一步</p>
		<div class="privileges-category">
			<span v-for="(category, index) in privilegesCategorys" @click.stop="goto(index)" :class="{'now-privilege': index === nowIndex}">{{ category }}</span>
			<span @click.stop="goto(2)" v-if="cardState === 20" :class="{'now-privilege': nowIndex === 2}"> <i class="icon-upgrade"></i> 专属客服</span>
		</div>
		<div class="index-wrap">
			<!--  @mouseout="runInv" -->
			<div class="slide-show" @mouseover="clearInv">
				<div class="slide-img">
					<transition name="slide-trans">
						<!--  class="privileges-container" -->
						<div v-if="isShow">
							<ul class="myPrivileges-in clearfix" :class="{'upgrade-privileges': cardState === 20}" key="0" v-show="nowIndex===0">
								<!-- 应聘优先 -->
								<li class="myPrivileges-card " @click.stop="show('ypyx')">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-ypyx-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">应聘优先</p>
											<p class="myPrivileges-card-des">投递简历优先展示</p>
											<div class="myPrivileges-cardbtn-wrap" v-if="vipState===2">
												<span class="myPrivileges-card-btn">立即使用</span>
											</div>
											<div class="myPrivileges-cardbtn-wrap" v-else>
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 简历置顶 -->
								<li class="myPrivileges-card " @click.stop="topResume">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-jlzd-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">简历置顶</p>
											<p class="myPrivileges-card-des">可使用{{leftTop}}天</p>
											<div class="myPrivileges-cardbtn-wrap">
												<span class="myPrivileges-card-btn">{{resumeListNum ? '立即置顶' : '创建简历'}}</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 极速沟通 -->
								<!-- <li class="myPrivileges-card " @click.stop="show('jsgt')">
									<dl>
										<dt><img src="../../../../assets/imgs/priv-jsgt-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">极速沟通</p>
											<p class="myPrivileges-card-des">企业电话极速查</p>
											<div class="myPrivileges-cardbtn-wrap" v-if="vipState===2">
												<span class="myPrivileges-card-btn">立即使用</span>
											</div>
											<div class="myPrivileges-cardbtn-wrap" v-else>
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li> -->
								<!-- 投递特权 -->
								<li class="myPrivileges-card " @click.stop="show('tdtq')">
									<dl>
										<dt><img src="../../../../assets/imgs/priv-tdtq-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">投递特权</p>
											<p class="myPrivileges-card-des">可投递25次</p>
											<div class="myPrivileges-cardbtn-wrap" v-if="vipState===2">
												<span class="myPrivileges-card-btn">立即使用</span>
											</div>
											<div class="myPrivileges-cardbtn-wrap" v-else>
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 免费刷新 -->
								<li class="myPrivileges-card " @click="show('wxsx')">
									<dl>
										<dt><img src="../../../../assets/imgs/priv-wxsx-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">免费刷新</p>
											<p class="myPrivileges-card-des">任性刷刷刷</p>
											<div class="myPrivileges-cardbtn-wrap" v-if="vipState===2">
												<span class="myPrivileges-card-btn">立即使用</span>
											</div>
											<div class="myPrivileges-cardbtn-wrap" v-else>
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 直通卡 -->
								<li class="myPrivileges-card " v-if="cardState === 20">
									<dl>
										<dt><img src="../../../../assets/imgs/priv-wxsx-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">直通服务</p>
											<p class="myPrivileges-card-des">直接面试直通名企</p>
											<div class="myPrivileges-cardbtn-wrap">
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 职业信用报告 -->
								<!-- <li class="myPrivileges-card" @click="goIntegrityReport">
									<dl>
										<dt><img src="//pic1.58cdn.com.cn/nowater/cxnomark/n_v2c8f8747706aa4d56a4e57365e4ec6c53.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">职业信用报告</p>
											<p class="myPrivileges-card-des">会员享1.5折</p>
											<div class="myPrivileges-cardbtn-wrap">
												<span class="myPrivileges-card-btn">去看看</span>
											</div>
										</dd>
									</dl>
								</li> -->
							</ul>
							<ul class="myPrivileges-in clearfix" key="1" v-show="nowIndex===1">
								<!-- 求职保障 -->
								<li class="myPrivileges-card " @click.stop="show('qzbz')">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-qzbz-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">求职保障</p>
											<p class="myPrivileges-card-des">无面试58包赔</p>
											<div class="myPrivileges-cardbtn-wrap" v-if="vipState===2">
												<span class="myPrivileges-card-btn">立即使用</span>
											</div>
											<div class="myPrivileges-cardbtn-wrap" v-else>
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 信息保真 -->
								<!-- <li class="myPrivileges-card " @click.stop="show('xxbz')">
									<dl>
										<dt><img src="../../../../assets/imgs/priv-xxbz-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">信息保真险</p>
											<p class="myPrivileges-card-des">求职更有保障更放心</p>
											<div class="myPrivileges-cardbtn-wrap" v-if="insuranceState===2">
												<span class="myPrivileges-card-btn">申请投保</span>
											</div>
											<div class="myPrivileges-cardbtn-wrap" v-else>
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li> -->
								<!-- 财产安全 -->
								<li class="myPrivileges-card " @click.stop="show('ccaq')">
									<dl>
										<dt><img src="../../../../assets/imgs/priv-ccaq-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">财产安全险</p>
											<p class="myPrivileges-card-des">为您的财产保驾护航</p>
											<div class="myPrivileges-cardbtn-wrap" v-if="insuranceState===2">
												<span class="myPrivileges-card-btn">申请投保</span>
											</div>
											<div class="myPrivileges-cardbtn-wrap" v-else>
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
							</ul>
							<!-- 专属客服 -->
							<ul class="myPrivileges-in clearfix" key="2" v-show="nowIndex===2" v-if="cardState === 20">
								<!-- 专属客服 -->
								<li class="myPrivileges-card ">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-zskf-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">专属客服</p>
											<p class="myPrivileges-card-des">24小时解疑答惑</p>
											<div class="myPrivileges-cardbtn-wrap" >
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 面试技巧 -->
								<li class="myPrivileges-card">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-hjld-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">面试技巧</p>
											<p class="myPrivileges-card-des">面试技巧相关培训</p>
											<div class="myPrivileges-cardbtn-wrap">
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 防骗安全提醒 -->
								<li class="myPrivileges-card ">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-fpaq-small.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">防骗安全提醒</p>
											<p class="myPrivileges-card-des">规避面试风险</p>
											<div class="myPrivileges-cardbtn-wrap">
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 尊贵标识 -->
								<li class="myPrivileges-card ">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-zgbs-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">简历服务</p>
											<p class="myPrivileges-card-des">提供优秀简历模板</p>
											<div class="myPrivileges-cardbtn-wrap">
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
								<!-- 应聘优先 -->
								<li class="myPrivileges-card ">
									<dl>
										<dt class="myPrivileges-card-img"><img src="../../../../assets/imgs/priv-ypyx-big.png" class="myPrivileges-card-img"></dt>
										<dd>
											<p class="myPrivileges-card-tit">用户关怀</p>
											<p class="myPrivileges-card-des">贴心定制化服务</p>
											<div class="myPrivileges-cardbtn-wrap">
												<span class="myPrivileges-card-btn myPrivileges-card-btnNo">正在使用</span>
											</div>
										</dd>
									</dl>
								</li>
							</ul>
						</div>
					</transition>
				</div>
				<ul class="slide-pages myPrivileges-slide-bar">
					<li v-for="(item, index) in slides" @click.stop="goto(index)" :key="index">
						<span class="bar-com" :class="{ 'bar-active':index===nowIndex }" :key="index"></span>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<resume-top-dialog v-if="showTop" @closeDialog='closeDialog' @topBtnChange='topBtnChange' @show-alert="showAlert"></resume-top-dialog>
	<gold-light-dialog v-if="showLight" @closeDialog='closeDialog' @lightBtnChange='lightBtnChange' @show-alert="showAlert"></gold-light-dialog>
	<zgbs-dialog v-if="showZgbs" @closeDialog='closeDialog' @buyDialog="buyDialog"></zgbs-dialog>
	<wxsx-dialog v-if="showWxsx" @closeDialog='closeDialog' @buyDialog="buyDialog"></wxsx-dialog>
	<qzfx-dialog v-if="showQzfx" @closeDialog='closeDialog' @buyDialog="buyDialog"></qzfx-dialog>
	<grrz-dialog v-if="showGrrz" @closeDialog='closeDialog' @buyDialog="buyDialog" @authDialog="showAuthDialog"></grrz-dialog>
	<jlzd-dialog v-if="showJlzd" @closeDialog='closeDialog' @buyDialog="buyDialog" @topResume="topResume"></jlzd-dialog>
	<hjld-dialog v-if="showHjld" @closeDialog='closeDialog' @buyDialog="buyDialog" @hightResume="hightResume"></hjld-dialog>
	<!-- 极速沟通 -->
	<!-- <jsgt-dialog v-if="showJsgt" @closeDialog='closeDialog' @buyDialog="buyDialog"></jsgt-dialog> -->
	<!-- 投递特权 -->
	<tdtq-dialog v-if="showTdtq" @closeDialog='closeDialog' @buyDialog="buyDialog"></tdtq-dialog>
	<!-- 求职保障 -->
	<qzbz-dialog v-if="showQzbz" @closeDialog='closeDialog' @compensateDialog="compensateDialog" @buyDialog="buyDialog" :vipState="vipVersionState"></qzbz-dialog>
	<!-- 信息保真 -->
	<!-- <xxbz-dialog v-if="showXxbz" @closeDialog='closeDialog' @compensateDialog="compensateDialog" @buyDialog="buyDialog" :vipState="vipVersionState"></xxbz-dialog> -->
	<!-- 财产安全 -->
	<ccaq-dialog v-if="showCcaq" @closeDialog='closeDialog' @compensateDialog="compensateDialog" @buyDialog="buyDialog" :vipState="vipVersionState" :insuranceState="insuranceState"></ccaq-dialog>
	<!-- 应聘优先 -->
	<ypyx-dialog v-if="showYpyx" @closeDialog='closeDialog' @buyDialog="buyDialog"></ypyx-dialog>
	<!-- 专属客服 -->
	<zskf-dialog v-if="showZskf" @closeDialog='closeDialog' @buyDialog="buyDialog"></zskf-dialog>
	<!-- 成功 alert -->
	<cvip-alert v-if="showSuccess" @on-hide="onHide" buttonTxt="我知道了" widthnew='450px' heightnew='200px' marginnew='-100px auto'>
		<span class="alert-icon icon-success"></span>
		<span>{{alertTxt}}</span>
	</cvip-alert>
</div>
</template>
<script>
import ResumeTopDialog from '../../modules/dialog/ResumeTopDialog'
import GoldLightDialog from '../../modules/dialog/GoldLightDialog'
import ZgbsDialog from '../../modules/dialog/ZgbsDialog'
import WxsxDialog from '../../modules/dialog/WxsxDialog'
import QzfxDialog from '../../modules/dialog/QzfxDialog'
import GrrzDialog from '../../modules/dialog/GrrzDialog'
import JlzdDialog from '../../modules/dialog/JlzdDialog'
import HjldDialog from '../../modules/dialog/HjldDialog'
// import JsgtDialog from '../../modules/dialog/JsgtDialog'  //极速沟通
import TdtqDialog from '../../modules/dialog/TdtqDialog'  //投递特权
import QzbzDialog from '../../modules/dialog/QzbzDialog'  //求职保障
import CcaqDialog from '../../modules/dialog/CcaqDialog'  //求职意外
// import XxbzDialog from '../../modules/dialog/XxbzDialog'  //信息保真
import YpyxDialog from '../../modules/dialog/YpyxDialog'  //应聘优先
import ZskfDialog from '../../modules/dialog/ZskfDialog'  //专属客服
import CvipAlert from "../../../../components/alert/Alert"
import {
	mapGetters,
	mapActions
} from 'vuex'
export default {
	name: 'myPrivileges',
	components: {
		ResumeTopDialog,
		GoldLightDialog,
		ZgbsDialog,
		WxsxDialog,
		QzfxDialog,
		GrrzDialog,
		JlzdDialog,
		HjldDialog,
		// JsgtDialog, //极速沟通
		TdtqDialog, //投递特权
		QzbzDialog, //求职保障
		// XxbzDialog, //信息保真
		CcaqDialog, //财产安全
		CvipAlert,
		YpyxDialog, //应聘优先
		ZskfDialog
	},
	props: ['vipState', 'cardState'],
	data() {
		return {
			mark: 0, //轮播图标记
			showTop: false, //简历置顶弹窗
			showLight: false, //亮点设置弹窗
			showZgbs: false, //尊贵标识弹窗
			showWxsx: false, //免费刷新
			showQzfx: false, //求职分析
			showGrrz: false, //个人认证
			showJlzd: false, //简历置顶
			showHjld: false, //黄金亮点
			// showJsgt: false, //极速沟通
			showTdtq: false, //投递特权
			showQzbz: false, //求职保障
			// showXxbz: false, //信息保真
			showCcaq: false, //财产安全
			showYpyx: false, //应聘优先
			showZskf: false, //专属客服
			nowIndex: 0,
			isShow: true,
			inv: 5000,
			slides: [
				{
					src: '',
					title: 'xxx1'
				},
				{
					src: '',
					title: 'xxx2'
				}
			],
			alertTxt: '', // 成功 alert 弹框内容
			showSuccess: false, // 成功 alert 弹框标志
			privilegesCategorys: ['求职特权', '求职保障'],
		}
	},
	created() {
		this.play();
	},
	mounted() {
		this.runInv();
	},
	methods: {
		/**
		 * 黄金亮点选择
		 * 当没有建立时引导创建简历
		 * 当简历已存在时打开“黄金亮点”弹框
		 */
		hightResume() {
			this.closeDialog()
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/")
				return
			}
			this.showLight = true
			window.clickLog && window.clickLog(`from=pc-cvip-gerentequan-hjbq-szbq-${this.cvipMes.cvipstate}-new`)
		},
		/**
		 * 简历置顶操作
		 * 当没有建立时引导创建简历
		 * 当简历已存在时打开”简历置顶“弹框
		 */
		topResume() {
			this.closeDialog()
			if (!this.resumeListNum) {
				window.open("//jianli.58.com/resumepost/view/fulltime/")
				return
			}
			this.showTop = true
			window.clickLog && window.clickLog(`from=pc-cvip-gerentequan-jlzd-ljzd-${this.cvipMes.cvipstate}-new`)
		},
		closeDialog() {
			this.showTop = false
			this.showLight = false
			this.showZgbs = false
			this.showWxsx = false
			this.showQzfx = false
			this.showGrrz = false
			this.showJlzd = false
			this.showHjld = false
			this.showJsgt = false
			this.showTdtq = false
			this.showQzbz = false
			// this.showXxbz = false
			this.showCcaq = false
			this.showYpyx = false
			this.showZskf = false
		},
		//赔付弹窗
		compensateDialog() {
			this.closeDialog();
			this.$emit('showCompensateDialog')
		},
		//认证弹窗
		showAuthDialog() {
			this.closeDialog();
			this.$emit('showAuthDialog')
		},
		lightBtnChange() {
			this.$store.commit('RIGHT_USED', {
				'4': true
			})
		},
		topBtnChange() {
			this.$store.commit('RIGHT_USED', {
				'5': true
			})
		},
		certification() {
			this.$emit('showAuthDialog')
		},
		show(type) {
			window.clickLog && window.clickLog(`from=pc-cvip-gerentequan-${type}-dj-${this.cvipMes.cvipstate}-new`)

			switch (type) {
				// case 'jsgt': //极速沟通
				// 	this.showJsgt = true
				// 	break
				case 'tdtq': //投递特权
					this.showTdtq = true;
					break;
				case 'qzbz': //求职保障
					this.showQzbz = true;
					break;
				// case 'xxbz': //信息保真
				// 	this.showXxbz = true;
				// 	break;
				case 'ccaq': //财产安全
					this.showCcaq = true;
					break;
				case 'zgbs':
					this.showZgbs = true
					break
				case 'wxsx':
					this.showWxsx = true
					break
				case 'qzfx':
					this.showQzfx = true
					break
				case 'grrz':
					this.showGrrz = true
					break;
				case 'jlzd':
					this.showJlzd = true
					break;
				case 'hjld':
					this.showHjld = true
					break;
				case 'ypyx':
					this.showYpyx = true
					break;
				case 'zskf':
					this.showZskf = true
					break;
			}
		},
		buyDialog() {
			this.closeDialog()
			this.$emit('showDialog')
		},
		//轮播图相关
		autoPlay() {
			this.mark++
			if (this.mark === 2) { //当遍历到最后一张图片置零
				this.mark = 0
			}
		},
		play() {
			if(this.cardState === 20) this.slides.push({});
			setInterval(this.autoPlay, 5000);
		},
		change(i) {
			this.mark = i
		},
		//轮播图相关
		goto(index) {
			this.isShow = false
			setTimeout(() => {
				this.isShow = true
				this.nowIndex = index
			}, 10)
		},
		runInv() {
			this.invId = setInterval(() => {
				this.goto(this.nextIndex)
			}, this.inv)
		},
		clearInv() {
			clearInterval(this.invId)
		},
		showAlert(txt) {
			this.alertTxt = txt
			setTimeout(() => {
				this.showSuccess = true
			}, 500)
		},
		onHide() {
			this.showSuccess = false
		},
		goIntegrityReport() {
			window.top.open('//certify.58.com/self/index?utm_source=pc-jinkatequan')
			window.clickLog && window.clickLog('from=pc-cvip-gerentequan_certify')
		}
	},
	//定义这个sweiper对象
	computed: {
		...mapGetters({
			cvipMes: 'cvipMes',
			leftTop: 'leftTop',
			rightUsed: 'rightUsed', //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
			resumeListNum: 'resumeListNum'
		}),
		prevIndex() {
			if (this.nowIndex === 0) {
				return this.slides.length - 1
			} else {
				return this.nowIndex - 1
			}
		},
		nextIndex() {
			if (this.nowIndex === this.slides.length - 1) {
				return 0
			} else {
				return this.nowIndex + 1
			}
		},
		vipVersionState(){ //会员状态   新版会员 || 老版会员
			return this.$store.getters.getinsurance.code
			// return 2
		},
		insuranceState(){
			return this.$store.getters.getAccidentInsuranceState.code
			// return 2
		}
	}
}
</script>

<style lang="scss" scope>
.myPrivileges {
    width: 100%;
}
.myPrivileges-out {
    width: 1260px;
    margin: 0 auto;
    padding: 70px 0 30px;
}
.myPrivileges-tit {
    margin-bottom: 12px;
    font-size: 36px;
    color: #000000;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-weight: 600;
}
.myPrivileges-des {
    margin-bottom: 40px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    color: #AAAAAA;
    text-align: center;
}

.privileges-category {
	margin: 30px 0 40px 0;
	padding-bottom: 12px;
	border-bottom: 1px solid #EEEEEE;
	text-align: center;
	color: #333333;
	font-size: 18px;
	span {
		position: relative;
		padding-bottom: 13px;
		margin-right: 70px;
		cursor: pointer;
		&.now-privilege{
			color: #CCA769;
		}
		&.now-privilege:before {
			position: absolute;
			content: '';
			display: inline-block;
			width: 40px;
			height:	4px;
			border-radius: 4px;
			background: #D4B277;
			bottom: 0;
			left: 0;
			right: 0;
			margin: 0 auto;
		}
		.icon-upgrade {
			position: absolute;
			right: -20px;
			top: -20px;
			display: inline-block;
			height: 18px;
			width: 54px;
			background: url(../../../../assets/imgs/icon-upgrade.png) no-repeat center;
			background-size: 100% 100%;
		}
	}
	span:last-child{
		margin-right: 0;
	}
}

.myPrivileges-card {
	font-size: 0;
	display: inline-block;
	margin-right: 20px;
    padding: 40px 0;
    // width: 222px;
	width: 182px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
}
.myPrivileges-card:last-child{
	margin-right: 0px;
}
.myPrivileges-card:hover {
    background: #FFFFFF;
    box-shadow: 0 0 12px 6px rgba(153,153,153,0.10);
    // .myPrivileges-card-img {
    //     width: 130px;
    //     height: 130px;
    // }
}
.myPrivileges-card-tit {
    margin: 26px auto 4px;
    font-size: 18px;
    color: #555555;
    line-height: 18px;
    font-weight: bold;
}
.myPrivileges-card-des {
    margin-bottom: 22px;
    font-size: 12px;
    color: #999999;
}
.myPrivileges-cardbtn-wrap {
    overflow: hidden;
    margin: 0 auto;
    width: 128px;
    height: 40px;
    line-height: 40px;
    border-radius: 100px;
}
.myPrivileges-card-btn {
    display: block;
    font-size: 14px;
    color: #fff;
    filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr= '#D2AF74',endColorStr='#FCCB78',gradientType='0');
    background-image: -webkit-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
    background-image: -o-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
    background-image: -moz-linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
    background-image: linear-gradient(-140deg, #D2AF74 0%, #FCCB78 100%);
    &:hover {
        opacity: 0.9;
    }
}
.myPrivileges-card-btnNo {
    background: #D8D8D8;
    filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr= '#D8D8D8',endColorStr='#D8D8D8',gradientType='0');
    &:hover {
        opacity: 1;
    }
}
.myPrivileges-card-img {
    margin: 0 auto;
    width: 80px;
    height: 80px;
    transition: all 0.2s ease;
}
//轮播效果
.myPrivileges-slide {
    position: relative;
    width: 1200px;
    height: 300px;
}
.myPrivileges-in {
    position: absolute;
	display: inline-block;
	width: 100%;
	text-align: center;
	white-space: nowrap;
}
.image-enter-active {
    transform: translateX(0);
    transition: all 1.5s ease;
}
.image-leave-active {
    transform: translateX(-100%);
    transition: all 1.5s ease;
}
.image-enter {
    transform: translateX(100%);
}
.image-leave {
    transform: translateX(0);
}

.slide {
    width: 1024px;
    height: 320px;
    margin: 50px auto 0;
    overflow: hidden;
    position: relative;
}
.myPrivileges-slide-bar {
    margin: 0 auto;
    text-align: center;
}
.bar-com {
    display: inline-block;
    margin-right: 3px;
    width: 7px;
    height: 7px;
    background: #DEC499;
    border-radius: 8px;
}
.bar-active {
    width: 23px;
    height: 7px;
    background: #DEC499;
    border-radius: 8px;
}
.swiper-item {
    display: inline-block;
}
.index-wrap {
    overflow: hidden;
}
.privileges-container {
	width: 100%;
	height: 100%;
}
.slide-trans-enter-active {
    transition: all 0.8s;
}
.slide-trans-enter {
    transform: translateX(1200px);
}
.slide-trans-old-leave-active {
    transition: all 0.8s;
    transform: translateX(-1200px);
}
.slide-show {
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 390px;
    overflow: hidden;
}
.slide-show h2 {
    position: absolute;
    width: 100%;
    color: #fff;
    background: #000;
    opacity: 0.5;
    bottom: 0;
    margin: 0;
    height: 32px;
    padding-left: 15px;
}
.slide-img {
    padding: 10px;
    width: 100%;
    height: 390px;
}
.upgrade-privileges {
	.myPrivileges-card {
		width: 182px;
	}
}
.slide-pages {
    z-index: 1000;
    position: absolute;
    bottom: 0;
    margin-bottom: 5px;
    left: 0;
    right: 0;
}
.slide-pages li {
    display: inline-block;
    margin: 0 2px;
    cursor: pointer;
    color: #fff;
    font-size: 16px;
}
.slide-pages li .on {
    color: deeppink;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// MyPrivileges.vue?695a9a8b